import { Injectable } from '@angular/core';
import { PopoverController } from '@ionic/angular';

import { DateRangePickerModalComponent } from './date-range-picker-modal.component';
import { DateRange } from './date-range-picker.component';

@Injectable({
  providedIn: 'root',
})
export class DateRangePickerService {
  constructor(private popoverCtrl: PopoverController) {}

  async openDateRangePicker(initialDateRange?: DateRange, event?: any): Promise<DateRange | undefined> {
    const popover = await this.popoverCtrl.create({
      component: DateRangePickerModalComponent,
      cssClass: 'date-range-picker-popover',
      componentProps: {
        initialDateRange,
      },
      event: event,
      showBackdrop: false,
      backdropDismiss: true,
    });

    await popover.present();

    const { data } = await popover.onDidDismiss();
    return data;
  }
}
